import { QueryKey, UseQueryResult, useQuery } from '@tanstack/react-query'

import { graphql } from '~explore/types/__generated/gql'
import { GetPopularMapsQuery } from '~explore/types/__generated/gql/graphql'
import { graphierQL } from '~explore/utils/graphierQL'

const queryGetPopularMaps = /* GraphQL */ `
  query GetPopularMaps {
    searchMaps(feedType: popular, size: 30) {
      total
      items {
        id
        dataId
        name
        description
        likes
        views
        createdAt
        updatedAt
        workspace {
          id
          name
          logo
        }
      }
    }
  }
`
graphql(queryGetPopularMaps)

type TGetPopularMapsResults = GetPopularMapsQuery['searchMaps']['items']

const GetPopularMapsKey = (): QueryKey => {
  return ['GetPopularMaps']
}

const getPopularMapsQueryFn = () =>
  graphierQL<GetPopularMapsQuery>({
    query: queryGetPopularMaps
  }).then((res) => res.searchMaps.items)

const useGetPopularMaps = (
  enabled?: boolean,
  initialData?: TGetPopularMapsResults
): UseQueryResult<TGetPopularMapsResults> => {
  return useQuery({
    enabled: enabled ?? true,
    queryKey: GetPopularMapsKey(),
    queryFn: getPopularMapsQueryFn,
    initialData
  })
}

const useGetPopularMapsCache = () => {
  return useGetPopularMaps(false)
}

export {
  GetPopularMapsKey,
  getPopularMapsQueryFn,
  queryGetPopularMaps,
  useGetPopularMaps,
  useGetPopularMapsCache
}
export type { TGetPopularMapsResults }
